export default "__VITE_ASSET__DNowyIig__"